import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserModel } from '../../../../shared/models/user.model';
import { AuthService } from '../services/auth.service';

@Directive({
  selector: '[appIsOwner]',
})
export class IsOwnerDirective implements OnDestroy {
  private subscription: Subscription;
  private value: any;

  constructor(
    private authService: AuthService,
    private templateRef: TemplateRef<any>,
    private viewContainerRef: ViewContainerRef,
  ) {
    this.subscription = this.authService.userData.subscribe((userData) =>
      this.updateView(userData),
    );
  }

  @Input()
  set appIsOwner(value: any) {
    this.value = typeof value === 'object' ? value : null;
    this.updateView(this.authService.userData.value);
  }

  private updateView(user: UserModel): void {
    this.viewContainerRef.clear();
    if (!user) {
      return;
    }
    if (this.value && this.value.owner && (this.value.owner === user.id || user.role === 'ADMIN')) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
